import API from '@/api/Dashboard'
import MixinFactory from '@/store/mixin'
import { PartialUpdate } from '@/utils'
const Mixin = MixinFactory('Dashboard')

let removeItemById = (target, id) => {
  if (!target) return
  let index = target.findIndex(t => t.id === id)
  if (!~index) return

  target.splice(index, 1)
}

let partialUpdateItemBy = (target, payload) => {
  if (!target) return

  let match = target.find(t => t.id === payload.id)
  if (!match) return

  PartialUpdate(match, payload, { strict: true })
}

const state = {
  ...Mixin.state,
}

const mutations = {
  ...Mixin.mutations,
  updateTask(state, payload) {
    partialUpdateItemBy(state.item.tasks, payload)
    partialUpdateItemBy(state.item.deadlines, payload)
    partialUpdateItemBy(state.item.lastActivity, payload)
  },
  removeTask(state, payload) {
    removeItemById(state.item.tasks, payload.id)
    removeItemById(state.item.deadlines, payload.id)
    removeItemById(state.item.lastActivity, payload.id)
  },
}

const actions = {
  fetch: Mixin.actions.fetch(API.get),
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
